<template>
  <!-- Error page-->
   
  <div class="container-fluid">
    <b-row>
      <b-col
        sm="12"
        class="text-right my-1"
      >
      <locale />
      </b-col>
    </b-row>

    <b-row class="d-flex justify-content-center pt-1">
       <b-col
        sm='12'
        class="text-center pb-1"
      >
      <b-link class="brand-logo" :to="{ name: 'landing'}">
        <img class="img_logo" :src="logo" alt="logo">
      </b-link>
      </b-col>
    </b-row>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center mt-2">
        <h2 class="mb-1">
          {{ $t('message.pagenotfound') }} 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          {{ $t('message.requestedurl') }}
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{path:'/landing'}"
        >
          {{ $t('message.backtohome') }}
        </b-button>

        <!-- image -->
        <b-img
          class="imgFluid"
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg, BRow, BCol } from 'bootstrap-vue'
import store from '@/store/index'
import Locale from '@/views/pages/components/Locale.vue'

export default {
  components: {
    BRow, 
    BCol,
    BLink,
    BButton,
    BImg,
    Locale,
  },
  data() {
    return {
      logo: require('@/assets/images/quotation/sft_logo.svg'),
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-misc.scss';
.img_logo {
  display: inline-block;
  margin: 0 auto;
  max-width: 650px;
  width: 80%;
  height: auto;
}
.imgFluid {
  display: block;
  margin: 0 auto;
  max-width: 100%; 
  height: auto;
}
</style>
